import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { appEnv } from '../config/app.env';

export const AuthConfig: UserManagerSettings = {
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  authority: appEnv.VITE_AUTH_SERVER,
  client_id: appEnv.VITE_AUTH_CLIENT,
  redirect_uri: `${window.location.origin}/callback`,
  silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: appEnv.VITE_AUTH_SCOPE,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorAnonymousSession: true,
  revokeTokensOnSignout: true
};
